/**
 * Menu event content
 * 
 * @module notify-flyout
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'notify-flyout';

if(!customElements.get(customElements.component)) {

	class notifyFlyout extends HTMLElement {

		/**
		 * Menu event content web component
		 * 
		 * @constructor
		 */
		constructor() {
			super();

            this.initEvents();

			window.notifyFlyout = this;
			
		}

		/**
		 * Init component events.
		 * 
		 * @returns {undefined}
		 */
		initEvents() {

			document.querySelectorAll('[data-notify-open]').forEach(openButton => {
				
				openButton.addEventListener('click', event => {
					event.preventDefault();

					let notifyFlyout = document.querySelector('[data-notify-flyout="' + openButton.dataset.notifyOpen + '"]');

					console.log(notifyFlyout);

					this.open(notifyFlyout);
				});
			});

			this.initEventsNotifyFlyout()
		}

		/**
		 * open Events Notify Flyout
		 * 
		 * @returns {undefined}
		 */
		open(notifyFlyout) {

			notifyFlyout.classList.remove('hidden');    
	
			notifyFlyout.setAttribute('aria-hidden', 'false');
	
			document.querySelector('[data-notify-overlay]').classList.add('active');
			document.querySelector('[data-global-overlay]').classList.remove('active');
		
			setTimeout(() => {
	
				notifyFlyout.classList.add('active');
	
				document.body.classList.add('overflow-hidden');
	
				this.initFocusTrap(notifyFlyout);
	
				this.activeFocusTrap();
			
				notifyFlyout.querySelector('[data-notify-close]').focus();
	
			}, 100);   
			
		}

		/**
		 * Init login flyout focus trap
		 * 
		 * @returns {undefined}
		 */
		initFocusTrap (notifyFlyout)  {

			this.focusTrap = focusTrap.createFocusTrap(notifyFlyout, { clickOutsideDeactivates: true });
		}

		/**
		 * Ative login flyout focus trap
		 * 
		 * @returns {undefined}
		 */
			activeFocusTrap ()  {

			if (this.focusTrap) {
				this.focusTrap.activate();
			}
		}

		/**
		 * Disable login focus trap
		 * 
		 * @returns {undefined}
		 */
		disableFocusTrap() {

			if (this.focusTrap) {
				this.focusTrap.deactivate();
			}
		}

		/**
		 * init Events Notify Flyout
		 * 
		 */
		initEventsNotifyFlyout() {
			document.querySelector('[data-notify-overlay]').addEventListener('click', (event) => {
				event.preventDefault();
				this.close();
			});

			document.querySelectorAll('[data-notify-close]').forEach( (btn) => {
				btn.addEventListener('click', (event) => {
					event.preventDefault();
					this.close();
				});
			});

			window.addEventListener('escape', (event) => {
				this.close();
			});
		}


		/**
		 * hide login flyout
		 * 
		 * @returns {undefined}
		 */
			close()  {

				document.querySelectorAll('[data-notify-flyout]').forEach(element => {
					if(element.classList.contains('active')) {

						this.disableFocusTrap();
		
						document.body.classList.remove('overflow-hidden');
		
						element.classList.remove('active');
	
						document.querySelector('[data-notify-overlay]').classList.remove('active');
				
						// We need to use set time out to avoid issues with menu animation
						setTimeout(() => {
							element.setAttribute('aria-hidden', 'true');
			
							element.classList.add('hidden');
				
						}, 500);
					}
				});
			}
		
	}

	customElements.define(customElements.component, notifyFlyout);
}
 